import cls from 'classnames';
import { Form } from 'react-bootstrap';
import { CATCH_DATE_PRESETS_DAYS } from 'src/utils/catches';

import classes from './Catches.module.scss';

export const CatchesFilterRow = ({
  filters,
  onFiltersChange,
  typeOptions = [],
  animalOptions = [],
  ageOptions = [],
  sexOptions = [],
}) => {
  const setFilter = (key) => (e) => onFiltersChange({ [key]: e.target.value });

  const mapPhotos = filters?.mapPhotos ?? 'all';

  return (
    <>
      <th>
        <Form.Control
          className={cls(classes.filterInput, { [classes.activeFilterInput]: !!filters?.trapName })}
          value={filters?.trapName ?? ''}
          placeholder={__('Search trap...')}
          onChange={setFilter('trapName')}
        />
      </th>

      <th>
        <Form.Select
          className={cls(classes.filterSelect, { [classes.activeFilterInput]: !!filters?.type })}
          value={filters?.type ?? ''}
          onChange={setFilter('type')}
        >
          <option value="">{__('All types')}</option>
          {typeOptions.map(({ type, title }) => (
            <option key={type} value={type}>{title}</option>
          ))}
        </Form.Select>
      </th>

      <th>
        <Form.Select
          className={cls(classes.filterSelect, { [classes.activeFilterInput]: !!filters?.datePeriodDays })}
          value={filters?.datePeriodDays ?? 0}
          onChange={(e) => onFiltersChange({ datePeriodDays: Number.parseInt(e.target.value) || 0 })}
        >
          <option value={0}>{__('All time')}</option>
          {CATCH_DATE_PRESETS_DAYS.map((days) => (
            <option key={days} value={days}>
              {__('Last {days} days').replace('{days}', days)}
            </option>
          ))}
        </Form.Select>
      </th>

      <th>
        <Form.Select
          className={cls(classes.filterSelect, { [classes.activeFilterInput]: !!filters?.animal })}
          value={filters?.animal ?? ''}
          onChange={setFilter('animal')}
        >
          <option value="">{__('All animals')}</option>
          {animalOptions.map(({ type, title }) => (
            <option key={type} value={type}>{title}</option>
          ))}
        </Form.Select>
      </th>

      <th>
        <Form.Select
          className={cls(classes.filterSelect, { [classes.activeFilterInput]: !!filters?.age })}
          value={filters?.age ?? ''}
          onChange={setFilter('age')}
        >
          <option value="">{__('All')}</option>
          {ageOptions.map(({ type, title }) => (
            <option key={type} value={type}>{title}</option>
          ))}
        </Form.Select>
      </th>

      <th>
        <Form.Select
          className={cls(classes.filterSelect, { [classes.activeFilterInput]: !!filters?.sex })}
          value={filters?.sex ?? ''}
          onChange={setFilter('sex')}
        >
          <option value="">{__('All')}</option>
          {sexOptions.map(({ type, title }) => (
            <option key={type} value={type}>{title}</option>
          ))}
        </Form.Select>
      </th>

      <th>
        <Form.Control
          className={cls(classes.filterInput, { [classes.activeFilterInput]: !!filters?.bait })}
          value={filters?.bait ?? ''}
          placeholder={__('Search...')}
          onChange={setFilter('bait')}
        />
      </th>

      <th>
        <Form.Select
          className={cls(classes.filterSelect, { [classes.activeFilterInput]: mapPhotos !== 'all' })}
          value={mapPhotos}
          onChange={setFilter('mapPhotos')}
        >
          <option value="all">{__('All')}</option>
          <option value="has_location">{__('Has location')}</option>
          <option value="no_location">{__('No location')}</option>
          <option value="has_photos">{__('Has photos')}</option>
          <option value="no_photos">{__('No photos')}</option>
        </Form.Select>
      </th>

      <th>
        <Form.Control
          className={cls(classes.filterInput, { [classes.activeFilterInput]: !!filters?.comment })}
          value={filters?.comment ?? ''}
          placeholder={__('Search...')}
          onChange={setFilter('comment')}
        />
      </th>
    </>
  );
};
